<template>
  <div>

    <vx-card>
      <vs-table
        class="pb-wide"
        stripe
        ref="table"
        :data="mails"
        search

        :sst="true"
        :max-items="itemsPerPage"
        @search="handleTableSearch"
        @selected="handleTableSelected">

        <template slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <vs-select autocomplete id="tableSelect" label="" v-model="itemsPerPage" class="w-1/12" @change="handleChangeTablePerPage">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in itemsPerPageOptions"/>
          </vs-select>
        </template>

        <template slot="thead">
          <vs-th class="" sort-key="groupName" >
            <vs-col vs-type="flex"  vs-justify="left" >
              번호
            </vs-col>
          </vs-th>
          <vs-th class="" sort-key="groupName" >
            <vs-col vs-type="flex"  vs-justify="center" >
              결재유형
            </vs-col>
          </vs-th>
          <vs-th class="" >
            <vs-col vs-type="flex"  vs-justify="center" >
              결재선명
            </vs-col>
          </vs-th>
          <vs-th class="" >
            <vs-col vs-type="flex"  vs-justify="center" >
              등록일
            </vs-col>
          </vs-th>
          <vs-th class="" >
            <vs-col vs-type="flex"  vs-justify="center" >
              미리보기
            </vs-col>
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

            <!-- 번호. -->
            <vs-td >
              {{ indextr }}
            </vs-td>

            <!-- 결재유형 -->
            <vs-td class="text-center">
              {{ data[indextr].approval_type }}
            </vs-td>

            <!-- 결재선명 -->
            <vs-td class="text-center">
              {{ data[indextr].name }}
            </vs-td>

            <!-- 등록일 -->
            <vs-td class="text-center">
              {{ data[indextr].created_at }}
            </vs-td>

            <!-- 미리보기 -->
            <vs-td class="td-fix-management text-center">
              <vs-button class="" color="primary" type="border" @click="(event)=>{ }">미리보기</vs-button>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>

      <div class="w-full text-right">
        <vs-button class="w-2/12" color="secondary" @click="handleFooterClickRegister">등록</vs-button>
      </div>

      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination
            :total="(lastPage) ? lastPage : 1"
            v-model="currentPage" @change="handleTableChangePage"></k-pagination>
        </div>
      </div>
    </vx-card>

    <popup-approval-process
      v-model="approvalLine"
      :show-popup="popupActive"
      @closePopup="handleCloseApprovalPopup" />
  </div>
</template>

<script>
import memberModule from '@/store/member/memberModule.js'
import PopupApprovalProcess from '@/views/content/approval/PopupApprovalProcess'
import KPagination from '@/views/components/kPagination/kPagination'

export default {
  name:'Process',
  components: {
    KPagination,
    PopupApprovalProcess},
  data () {
    return {
      selected: [],
      itemsPerPageOptions: [
        { text: '10', value: 10 },
        { text: '20', value: 20 },
        { text: '50', value: 50 }
      ],
      mails: [],

      // pagination
      startNo: 1,
      lastPage: 1,
      totalCount: 1,
      currentPage: 1,
      itemsPerPage: 10,
      popupActive:false
    }
  },
  computed: {
  },

  created () {

    // 동적 모듈 등록
    if (!this.$store.hasModule('member')) {
      this.$store.registerModule('member', memberModule)
    }

    this.mails = [
      { approval_type:'유형A', name: '결재선1', created_at: '2020-10-10'},
      { approval_type:'유형B', name: '결재선2', created_at: '2020-10-10'},
      { approval_type:'유형C', name: '결재선3', created_at: '2020-10-10'}
    ]
  },
  mounted () {
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.table.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  beforeDestroy () {
    // 동적 모듈 삭제
    this.$store.unregisterModule('member')
  },

  methods: {
    loadSendMail () {

    },


    //===== [ dev ] =====

    is_number (v) {
      const reg = /^(\s|\d)+$/
      return reg.test(v)
    },


    //===== [ handler ] ======

    handleFooterClickRegister () {
      this.popupActive = true
    },
    handleChangeTablePerPage (per_page) {
      if (this.is_number(per_page)) {
        this.itemsPerPage = per_page
      }
      this.currentPage = 1
      this.loadSendMail(this.currentPage)
    },
    handleTableChangePage (page) {
      this.loadSendMail(page)
    },
    handleTableSearch (keyword) {
      const page = this.currentPage
      this.loadSendMail(page, keyword)
    },
    handleTableSelected (tr) {
      if (!tr) {
        return
      }
      this.moveModified(tr.id)
    },
    handlePopupClose () {
      this.popupActive = false
    },
    handleCloseApprovalPopup (data) {
    }
  }//methods
}
</script>

<style scoped>
.th-fix-management,
.td-fix-management{
  width:214px;
}

.pb-wide{ margin-bottom:1.5rem !important;}

.tip { padding:24px; background-color: #fff; }
.tip p {color:#757575}
.tip p.warning {color:red; font-weight: 500}
</style>
